export interface RollOperation {
	PartId: number;
	PartName: string;
	LocationId: number | null;
	LocationName: string | null;
	LocationKey: string;
	RollPosition: string;
	RollTypeCode: string;
	RollStatusCode: string;
	Diameter: number;
	NewDiameter: number;
	ScrapDiameter: number;
	FoundryNumber: number;
	Stands: string | null;
	StandsId: string | null;
	Sections: string | null;
	SectionsId: string | null;
	Passes: string | null;
	PassesStatus: string | null;
	DonutPartId: number | null;
	DonutPartName: string | null;
	ArborPartId: number | null;
	ArborPartName: string | null;
	DonutStatusCode: string | null;
	CertificateURL: string;
	DonutCertificateURL: any;

	RollOperationId: number;
	OperationPartId: number;
	OperatorId: number | null;
	OperatorName: string | null;
	OperationLocationId: number | null;
	OperationLocationName: string | null;
	RollOperationTypeCode: string | null;
	OperationTypeDescription: string | null;
	OperationTimestamp: Date | null;
	OperationIsActive: boolean;
	OperationComments: string | null;
	DaysSinceOperation: number | null;
	HoursSinceOperation: number | null;
	IsRecentOperation: boolean;
	OperationAge: string | null;
	TotalOperations: number;
	AccumulatedTons: number;
	AccumulatedBillets: number;
}

export const OPERATION_INITIAL_VALUES: RollOperation = {
	PartId: 0,
	PartName: "",
	LocationId: null,
	LocationName: null,
	LocationKey: "",
	RollPosition: "",
	RollTypeCode: "",
	RollStatusCode: "",
	Diameter: 0,
	NewDiameter: 0,
	ScrapDiameter: 0,
	FoundryNumber: 0,
	Stands: null,
	StandsId: null,
	Sections: null,
	SectionsId: null,
	Passes: null,
	PassesStatus: null,
	DonutPartId: null,
	DonutPartName: null,
	ArborPartId: null,
	ArborPartName: null,
	DonutStatusCode: null,
	CertificateURL: "",
	DonutCertificateURL: null,

	RollOperationId: 0,
	OperationPartId: 0,
	OperatorId: null,
	OperatorName: null,
	OperationLocationId: null,
	OperationLocationName: null,
	RollOperationTypeCode: null,
	OperationTypeDescription: null,
	OperationTimestamp: null,
	OperationIsActive: true,
	OperationComments: null,
	DaysSinceOperation: null,
	HoursSinceOperation: null,
	IsRecentOperation: false,
	OperationAge: null,
	TotalOperations: 0,
	AccumulatedTons: 0,
	AccumulatedBillets: 0,
};
